import { Star } from "lucide-react"

interface Props {
  /** If true renders the full pill; if false renders a compact dot version */
  size?: "full" | "compact"
  className?: string
}

/**
 * Shown next to homeowner names throughout the app wherever they appear:
 * job cards, project cards, bid lists, profile pages.
 */
export default function PreferredBadge({ size = "full", className = "" }: Props) {
  if (size === "compact") {
    return (
      <span
        title="Preferred Homeowner — verified 3+ transactions"
        className={`inline-flex items-center justify-center w-4 h-4 rounded-full bg-amber-400 ${className}`}
      >
        <Star className="w-2.5 h-2.5 text-white fill-white" />
      </span>
    )
  }

  return (
    <span
      className={`inline-flex items-center gap-1 text-xs font-semibold bg-amber-50 text-amber-700 border border-amber-200 px-2 py-0.5 rounded-full ${className}`}
    >
      <Star className="w-3 h-3 fill-amber-500 text-amber-500" />
      Preferred
    </span>
  )
}
